import { SideDrawer, Toaster } from 'front-commons/ds';
import { SideDrawerProps } from 'front-commons/ds/components/SideDrawer/interfaces';
import { useEffect, useMemo } from 'react';
import useDrawer from 'stores/drawer';
import { DrawersId } from 'stores/drawer/interfaces';

export default function RegisteredDrawers() {
	const { handleCloseAllDrawers, drawerStore, handleCloseDrawer } = useDrawer();

	const drawersOpenedMemo = useMemo(() => {
		return drawerStore.drawers;
	}, [drawerStore.drawers]);

	useEffect(() => {
		document.body.style.overflow = drawersOpenedMemo.length > 0 ? 'hidden' : 'initial';
	}, [drawersOpenedMemo]);

	return (
		<>
			<Toaster target="drawer" openedDrawerProps={drawersOpenedMemo?.at(-1) as SideDrawerProps} />
			{drawerStore.drawers.map(({ children, ...rest }, index) => (
				<SideDrawer
					key={index}
					position={index + 1}
					index={index + 1}
					onClose={() => {
						handleCloseAllDrawers();
						rest.data?.onClose?.();
					}}
					{...rest}
					title={drawerStore.dynamicTitle.find(({ drawerId }) => drawerId === rest.id)?.title || rest.title}
					subtitle={drawerStore.dynamicSubtitle.find(({ drawerId }) => drawerId === rest.id)?.text}
					onGoBack={
						drawerStore.drawers.length > 1 && rest.showReturnButton
							? () => {
									rest.data?.onGoBack?.();
									handleCloseDrawer(rest.id as DrawersId);
							  }
							: undefined
					}
				>
					{children}
				</SideDrawer>
			))}
		</>
	);
}
